import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GameState, IGame, GameCallboard, WordsearchGameCallBoard, IWordsearchGameCallboardItem , IGameCallboardItem, IGameStateChangedArgs, IGameRepresentationChangedArgs } from '@/components/game/_domain/models';
import TombolaBaseComponent from '@/components/base/base.component';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { IWordSearchGameRepresentation } from '../../_domain/controller/game-controller';

@Component({
  name: 'WordSeachCallboardComponent',
})
export default class WordSeachCallboardComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private isVisible: boolean = true;
  private callboard: WordsearchGameCallBoard = null;

  private get callboardItems(): IWordsearchGameCallboardItem[] {
    return this.callboard ? this.callboard.items : [];
  }

  private mounted(): void {
    const game = this.gameController.getGame();
    this.updateCallboardVisibility(game.state);
    this.updateCallboard(game.representation);

    Vue.nextTick(() => {
      this.gameController
        .onGameStateChanged(this.handleGameStateChanged)
        .onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    const gameState = eventArgs.currentGameState;
    this.updateCallboardVisibility(gameState);
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation: IWordSearchGameRepresentation = eventArgs.currentGameRepresentation;
    this.updateCallboard(gameRepresentation);
  }

  private updateCallboardVisibility(gameState: GameState) {
    this.isVisible = gameState !== GameState.WinnersDisplayed;
  }

  private updateCallboard(gameRepresentation: IWordSearchGameRepresentation) {
    this.callboard = gameRepresentation.wordSearchCallBoard;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/wordsearch/_components/callboard/callboard.component.ts